/*
 *  日志
 *
 * *
 * */
import { logClient } from "@/api/index";
import { ListOpLogParamsReq, ListOpLogReq, ListThirdpartyLogParamsReq, ListThirdpartyLogReq } from "@/pbjs/xcommon/log_pb";
import { Page } from "@/utils/index";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
import InnerRequest from "./request";

export interface Options {
    Page: Page;
    id: string; // ID
    opUid: number; //操作人ID
    relatedId: number; //关系ID
    opCode: number; //操作名
    opTable: string; //操作表
    month: string; //月份
    beginDate: string; //开始时间
    endDate: string; //结束时间
}
export interface thirdpartyOptions {
    Page: Page;
    id: string; // ID
    thirdparty: string; // 三方名称
    relatedTid: string; //关联业务id
    relatedUid: string; //关联业务用户ID，
    apiType: string; //功能分类
    api: string; //API URL
    apiTag: string; //ApiTag
    request: string; //请求体
    response: string; //响应体
    httpResponseCode: number; //响应Code
    consumingStart: number; //耗时开始
    consumingEnd: number; //耗时结束
    requestAppKey: string; //三方的账号
    fromAppKey: string; // 目前没用
    isFailure: number; //是否是服务故障
    isBilling: number; //是否收费
    beginDate: string;
    endDate: string;
}

export function getListOpLogReq(arg: Options) {
    let request: any = new ListOpLogReq();
    request.setPagein(setPage(arg.Page.pageIndex, arg.Page.pageSize));
    request.setId(arg.id);
    request.setOpuid(arg.opUid);
    request.setRelatedid(arg.relatedId);
    request.setOpcode(arg.opCode);
    request.setOptable(arg.opTable);
    request.setMonth(arg.month);
    request.setBegindate(arg.beginDate);
    request.setEnddate(arg.endDate);
    return request;
}
// 获取查询列表
export const getListOpLogRequest = new InnerRequest(
    logClient,
    logClient.listOpLog
);
export function getListOpLogParamsReq() {
    let request: any = new ListOpLogParamsReq();
    return request;
}
// 获取oplog参数
export const getListOpLogParamsRequest = new InnerRequest(
    logClient,
    logClient.listOpLogParams
);

export function getListThirdpartyLogParamsReq() {
    let request: any = new ListThirdpartyLogParamsReq();
    return request;
}
// 获取thirdparty 参数
export const getListThirdpartyLogParamsRequest = new InnerRequest(
    logClient,
    logClient.listThirdpartyParams
);

export function getListThirdpartyLogReq(arg: thirdpartyOptions) {
    let request: any = new ListThirdpartyLogReq();
    request.setPagein(setPage(arg.Page.pageIndex, arg.Page.pageSize));
    request.setId(arg.id);
    request.setThirdparty(arg.thirdparty);
    request.setRelatedtid(arg.relatedTid);
    request.setRelateduid(arg.relatedUid);
    request.setApitype(arg.apiType);
    request.setApi(arg.api);
    request.setApitag(arg.apiTag);
    request.setRequest(arg.request);
    request.setResponse(arg.response);
    request.setHttpresponsecode(arg.httpResponseCode);
    request.setConsumingstart(arg.consumingStart);
    request.setConsumingend(arg.consumingEnd);
    request.setRequestappkey(arg.requestAppKey);
    request.setFromappkey(arg.fromAppKey);
    request.setIsfailure(arg.isFailure);
    request.setIsbilling(arg.isBilling);
    request.setBegindate(arg.beginDate);
    request.setEnddate(arg.endDate);
    return request;
}
// 获取thirdparty日志列表
export const getListThirdpartyLogRequest = new InnerRequest(
    logClient,
    logClient.listThirdpartyLog
);
